// @flow

const hostname = window && window.location && window.location.hostname;

let baseUrl;
let apiUrl;
let apiUrl_test;
let legacyApiUrl;
let sportsInsightsBaseUrl;

if (hostname.indexOf('dev') > -1 || hostname.indexOf('qa') > -1 || hostname.indexOf('localhost') > -1) {
    baseUrl = 'https://qa.fantasylabs.com';
    legacyApiUrl = 'https://qa.fantasylabs.com/api/v2';
    apiUrl_test = 'https://apitest.fantasylabs.com/api';
    apiUrl = 'https://service.fantasylabs.com';
    sportsInsightsBaseUrl = 'https://sportsinsights-dev.actionnetwork.com';
} else {
    baseUrl = 'https://www.fantasylabs.com';
    legacyApiUrl = 'https://www.fantasylabs.com/api/v2';
    apiUrl_test = 'https://service.fantasylabs.com';
    apiUrl = 'https://service.fantasylabs.com';
    sportsInsightsBaseUrl = 'https://sportsinsights.actionnetwork.com';
}

const isSportsInsightsUrl = hostname.indexOf('sportsinsights') > -1;

export default {
    fantasyLabsUrl: baseUrl,
    fantasyLabsApiUrl: apiUrl,
    fantasyLabsApiUrl_test: apiUrl_test,
    fantasyLabsLegacyApiUrl: legacyApiUrl,
    fantasyLabsApiVersion: 1,
    sportsInsightsBaseUrl,
    isSportsInsightsUrl
};



// WEBPACK FOOTER //
// ./src/config/environment.js